import { Component, inject } from '@angular/core';
import { IonicModule } from "@ionic/angular";
import { RockService } from '../services/rock/rock.service';
import { ServiceFactoryService } from '../services/service-factory.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedService } from '../services/rock/shared.service';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule],
})
export class HomeComponent {

  public rockService = inject(RockService);
  private serviceFactory = inject(ServiceFactoryService);
  private sharedService = inject(SharedService);

  names: string[] = [];
  filteredNames: string[] = [];
  inputData = '';

  controller: {
    controllerName: string,
    controller: any
  };

  constructor() {}

  async getNames() {
    this.names = await this.rockService.getRestControllerNames();
    this.filteredNames = this.sharedService.deepCopy(this.names);
  }

  async getController(name: string) {
    this.controller = {controllerName: name, controller: await this.rockService.getRestContoller(name)};
  }

  filterNames() {
    this.names = this.filteredNames.filter(name => {
      if (name.toLowerCase().indexOf(this.inputData.toLowerCase()) > -1) {
        return name;
      } 
    });
  }

  createService() {
    if (this.controller) {
      this.serviceFactory.createInterfaceFromDefinitions(this.controller);
      this.serviceFactory.createServiceFromPath(this.controller);
    }
  }

}
